import yandex from 'modules/metrics/events/eventYM.js'
import google from 'modules/metrics/events/eventGA.js'

export default function sendMetrics(obj) {
    if (obj.counterYM)
        yandex({ counter: obj.counterYM, target: obj.target })

    if (obj.counterGA)
        google({ counter: obj.counterGA, category: obj.category, action: obj.action })
}